import React from "react";
import { InfiniteScroll } from "nq-component";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import BaseListPage from "../../../../../base/BaseListPage";
import Table from "../../../../../components/Table";
import withRouter from "../../../../../withRouter";
import NavBar from "../../../../../components/NavBar";
import CardView from "../../../../../components/common/CardView";
import Search from "../../../../../components/Search";
import ViewNominationPresenter from "./ViewNominationPresenter";
import Queue from "nq";
import Progress from "../../../../../components/Progress";

class ViewNominationList extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new ViewNominationPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      objects: [],
      newObj: [],
      objTitle: "",
      count: 0,
      limit: 10,
      current: 1,
    };
  }

  // async componentDidUpdate(prevProps, prevState) {
  //   if (prevProps.getObjectID !== this.props.getObjectID) {
  //     const query = {
  //       where: {
  //         title: this.props.getObjectID,
  //       },
  //     };
  //     const newObj = await findObjectUseCase().execute(
  //       "approve_nomination",
  //       query
  //     );
  //     this.setState({ newObj: newObj, count: newObj.length });
  //   }
  // }

  getObjectTitle() {
    // const nomination = await findObjectUseCase().execute("nomination_list");
    // console.warn("NMOMI", nomination);
    return this.props.objTitle;
  }

  getCollectionName() {
    return "approve_nomination";
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  async handleRecipient(obj) {
    const { stats, ...object } = obj;
    const newOBJ = { stats: "Pending", ...object };
    await upsertUseCase().execute("recipient_log", newOBJ);
    // await deleteObjectUseCase().execute("approve_nomination", newOBJ.id);
    await new Queue.Document().delete("approve_nomination", newOBJ.id);
    // const query = {
    //   where: {
    //     title: obj.title,
    //   },
    // };
    // const deleteApprove = await findObjectUseCase().execute(
    //   "approve_nomination",
    //   query
    // );
    // for (const approve of deleteApprove) {
    //   await deleteObjectUseCase().execute("approve_nomination", approve.id);
    // }
    // const nominationReq = await findObjectUseCase().execute(
    //   "nomination_request",
    //   query
    // );
    // for (const request of nominationReq) {
    //   await deleteObjectUseCase().execute("nomination_request", request.id);
    // }

    // const openForNomi = await findObjectUseCase().execute(
    //   "open_for_nomination",
    //   query
    // );
    // for (const openNomi of openForNomi) {
    //   await deleteObjectUseCase().execute("open_for_nomination", openNomi.id);
    // }

    // const specialAwards = await findObjectUseCase().execute("special_award", {
    //   where: { title: object.title },
    // });

    // const { isEnable, ...specialAward } = specialAwards[0];
    // await upsertUseCase().execute("special_award", {
    //   isEnable: "enable",
    //   ...specialAward,
    // });
    this.showSuccess("Success");
    this.refetchData();
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());

    const { objects, loading, count, limit, current } = this.state;
    // const empPointer = objects
    //   .filter((item) => typeof item.employee === "object")
    //   .map((item) => item.employee);
    if (!schema) return <Progress />;
    return (
      <>
        <div className="m-3">
          {/* <div
            className="d-flex mb-4 mt-5"
            style={{ borderBottom: "1.5px solid #d3d3d3" }}
          >
            <p
              className="mt-2"
              style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}
            >
              You are here: Home {">"} Merit Reward and Recognition {">"}{" "}
              <span style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}>
                {schema.collection}
              </span>
            </p>
          </div> */}
          <div className="mb-4">
            {/* <CardView style={{ borderRadius: 0 }}> */}
            <Search
              schemas={this.getSchemas()}
              onSubmit={this.searchSubmit.bind(this)}
              fields={schema.fields}
            />
            {/* </CardView> */}
          </div>
          <InfiniteScroll loadMore={this.loadMore.bind(this)}>
            <div
              style={{
                marginTop: "20px",
                width: "100%",
              }}
            >
              <CardView style={{ borderRadius: 0 }}>
                <div className="d-flex align-items-center justify-content-start">
                  <h4 className="text-primary">
                    {/* {schema.label} */}
                    Recognition List
                  </h4>
                </div>
              </CardView>
            </div>

            <Table
              // empPointer={empPointer}
              // objectId={this.handleDeleteData.bind(this)}
              // editId={this.handleRecipient.bind(this)}
              objectData={this.handleRecipient.bind(this)}
              progress={loading}
              refetch={this.refetchData.bind(this)}
              fields={schema.fields}
              objects={objects}
              collection={schema}
              count={count}
              limit={limit}
              current={current}
              loadPagination={this.onClickPagination.bind(this)}
              actionsList={[
                {
                  label: "Recipients",
                  actionType: "object",
                },
              ]}
              excludeFields={Object.keys(schema.fields).reduce(
                (acc, key) => {
                  const options = schema.fields[key];
                  if (options.read === false) {
                    acc.push(key);
                  }
                  switch (options._type || options.type) {
                    case "Relation":
                    case "Array":
                    case "Object":
                    case "File":
                      acc.push(key);
                      break;
                    default:
                  }
                  return acc;
                },
                [
                  "id",
                  "Created At",
                  "Updated At",
                  "description",
                  "qualification",
                ]
              )}
              onClickItem={this.onClickItem.bind(this)}
            />
          </InfiniteScroll>
        </div>
      </>
    );
  }
}
export default ViewNominationList;
